const scripts: { [url: string]: Promise<void> } = {};
const scriptElements: { [url: string]: HTMLScriptElement } = {};

export default (url: string): Promise<void> => {
  if (!(url in scripts)) {
    const element = document.createElement('script');
    element.src = url;
    scripts[url] = new Promise<void>((resolve, reject) => {
      element.onload = () => {
        scriptElements[url] = element;
        resolve();
      };
      element.onerror = reject;
      document.body.appendChild(element);
    });
  }
  return scripts[url];
};

export function unloadScript(url: string) {
  const element = scriptElements[url];
  if (element) {
    delete scriptElements[url];
    delete scripts[url];
    console.debug('Removing script element for', url);
    document.body.removeChild(element);
  }
}
